module.exports = __webpack_public_path__ + "missing.08056c306b3e39aa94b3.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@c4/assets/src/assets/images/missing.svg
// module id = 65
// module chunks = 2